import { apiFetch, apiUrl } from '../api'
export async function experimentApi(path, body) {
  const response = await apiFetch(`experiments/${path}`, body === undefined ? {} : { method: 'POST', body: JSON.stringify(body) })
  const data = await response.json()
  if (!response.ok) {
    const error = new Error(data.error?.message || data.error || 'Request failed. Try again.')
    error.code = data.error?.code
    error.status = response.status
    throw error
  }
  return data
}
export async function uploadRoster(id, file) {
  const form = new FormData(); form.append('file', file)
  const token = localStorage.getItem('writing-demo-token')
  const response = await fetch(apiUrl(`experiments/admin/${id}/roster/preview`), { method: 'POST', credentials: 'include', headers: token ? { Authorization: `Bearer ${token}` } : {}, body: form })
  const data = await response.json()
  if (!response.ok) throw new Error(data.error?.message || 'Could not preview roster.')
  return data
}
export async function downloadResearch(id, kind, includePreview, includeTest = false) {
  const response = await apiFetch(`experiments/admin/${id}/export?kind=${kind}&include_preview=${includePreview}&include_test=${includeTest}`)
  if (!response.ok) throw new Error('Export is unavailable.')
  const url = URL.createObjectURL(await response.blob())
  const link = document.createElement('a'); link.href = url; link.download = response.headers.get('Content-Disposition')?.match(/filename="?([^";]+)/)?.[1] || `experiment-${id}-${includeTest ? 'TEST-' : ''}${kind}.csv`; link.click()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
export const getAssignmentSetup = (id, query = {}) => experimentApi(`admin/${id}/assignment-setup?${new URLSearchParams(query)}`)
export const saveAssignmentSetup = (id, payload) => experimentApi(`admin/${id}/assignment-setup`, payload)
export const publishAssignmentStudy = (id, payload) => experimentApi(`admin/${id}/publish-assignment`, payload)
export const getMaterialSources = (offset = 0) => experimentApi(`admin/material-sources?limit=100&offset=${offset}`)
export const copyStudyMaterials = (id, payload) => experimentApi(`admin/${id}/copy-materials`, payload)
export async function previewAssignmentRoster(id, file, revision) {
  const form = new FormData(); form.append('file', file); form.append('revision', revision)
  const token = localStorage.getItem('writing-demo-token')
  const response = await fetch(apiUrl(`experiments/admin/${id}/assignment-roster-preview`), {method:'POST', credentials:'include', headers:token ? {Authorization:`Bearer ${token}`} : {}, body:form})
  const data = await response.json()
  if (!response.ok) throw new Error(data.error?.message || 'Could not read the group file.')
  return data
}
